import ApiConstant from "./ApiContstant";
import DataService from "./DataService";

export interface GetUserBookingRequest {
  //Either Id or EmailAddress can be used but at least one is required
  Id?: number[];
  EmailAddress?: string;
  Date?: string; // Optional: Defaults to the current day
  Location?: {
    // Optional
    LocationId: number; // Optional: Location ID if available
    Country: string;
    City: string;
    Site: string;
    Building: string;
    Floor: string;
    Zone: string;
  };
}

export interface UserBooking {
  BookingId: number; // The unique booking ID number
  AllDay: boolean; // Is it an all day booking 0 = No 1 = Yes
  Start: string; // Start time for the booking in 24hr
  StartIn: number; // Nunber of minutes until the booking starts
  End: string; // End time for the booking in 24hr
  EndsIn: number; // Number of minutes until the booking ends
  Setup: string;
  Cleardown: string;
  StartTimeOriginal: string;
  Subject: string; // Booking subject
  Description: string; // Booking description
  Organiser: {
    Id: number; // ID number for the organiser
    FirstName: string;
    LastName: string;
    EmailAddress: string;
    UserImage: string; // Path to current user image
  };
  Attendees: [
    // An array of user objects for all attendees for the booking.
    {
      Id: number; // ID number for the organiser
      FirstName: string;
      LastName: string;
      EmailAddress: string;
      UserImage: string; // Path to current user image
    }
  ];
  BookedUser: {
    // Object for the user who created the booking
    Id: number; // ID number for the booking user
    FirstName: string;
    LastName: string;
    EmailAddress: string;
    UserImage: string; // Path to current user image
  };
  Resource: {
    Id: number; // DB ID for the resource profile
    ResId: number; // User facing ID number for resource profile
    Name: string; // Resource display name
    SpaceType: string;
    RoomImg: string;
    Occ: number;
    Description: string;
    Keywords: [string];
    Equips: [
      {
        ResourceId: number;
        EquipmentId: number;
        ImagePath: string;
        Name: string;
        FaultImagePath: string;
      }
    ];
    Location: {
      LocationId: number;
      Country: string;
      City: string;
      Site: string;
      Building: string;
      Floor: string;
      Zone: string;
    };
    MapID: number;
    SetupDuration: number;
    CleardownDuration: number;
    LastUsedOrLastCleaned: string;
    CheckInMandatorySpaceUsageAcceptanceText: string;
  };
  MeetingStatus: string;
  Actions: {
    Cancel: boolean;
    CheckIn: boolean;
    CheckOut: boolean;
    Extend: boolean;
  };
  ParentBookingId: number;
  RecurringOption: null;
  MeetingText: string;
  RingFenceBookingId: string;
}

export interface SpaceKeyword {
  ResourceId: number;
  Keyword: string;
}

export interface SpaceEquipment {
  ResourceId: number;
  EquipmentId: number;
  Name: string;
  ImagePath: string;
  FaultImagePath?: string;
}

export interface SpaceDetail {
  Id: number;
  ResID: number;
  ResName: string | null;
  Status: number;
  TitleMandatory: boolean;
  RoomImage: string;
  Occupancy: number;
  Description: string;
  Keywords: SpaceKeyword[];
  Equipment: SpaceEquipment[];
  Location: string | null;
  SpaceType: string;
  SpaceTypeIcon: string | null;
  MapID: number;
  SetupDuration: number;
  CleardownDuration: number;
  LastUsedOrLastCleaned: string | null;
  IsRecurringBookingEnabled: boolean;
  BookMandatorySpaceUsageAcceptanceText: string;
  CheckInMandatorySpaceUsageAcceptanceText: string;
}

export interface BookingCheckInRequest {
  bookid: number;
  loginuser: string;
  loginusername: string;
  resid: number;
}

export interface BookingCheckOutRequest {
  iscleardownaction: number;
  bookid: number;
  loginuser: string;
  loginusername: string;
  resid: number;
}

export interface CancelBookingRequest {
  bookingid: number;
  parentBookingId: number | null;
  userid: string
}

export interface ExtendBookingRequest {
  addmins: string;
  bookid: number;
  loginuser: string;
  loginusername: string;
  resid: number;
  extendedfrom: number | null;
}

class UserBookingService {
  async getUserBookings(
    payload: GetUserBookingRequest
  ): Promise<UserBooking[]> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetUserBookings,
      payload
    );

    return response?.data?.d ?? [];
  }

  async BookingCheckIn(
    payload: BookingCheckInRequest
  ) {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.BookingCheckIn,
      payload
    );

    return response?.data?.d ?? [];
  }

  async BookingCheckOut(
    payload: BookingCheckOutRequest
  ) {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.BookingCheckOut,
      payload
    );

    return response?.data?.d ?? [];
  }

  async BookingExtend(
    payload: ExtendBookingRequest
  ) {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.BookingExtend,
      payload
    );

    return response?.data?.d ?? [];
  }

  async BookingCancel(
    payload: CancelBookingRequest
  ) {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.BookingCancel,
      payload
    );

    return response?.data?.d ?? [];
  }
}

export default new UserBookingService;
